import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const MainMenu = ({ searchBtnClicked }) => {
  const [focused, setFocused] = useState(false);
  const [searchWord, setSearchWord] = useState("");

  return (
    <>
      <MainMenuWrap>
        <MainLogoBox>
          <Link to="/projectdongstagram">
            <img
              className="pcLogo"
              src="https://dongsooo.github.io/imgs/dongstgram_img/00_main_logo.png"
              alt="메인 로고"
            />
          </Link>
          <Link to="/projectdongstagram">
            <img
              className="tabletLogo"
              src="https://dongsooo.github.io/imgs/dongstgram_img/00_main_logo_tablet.png"
              alt="메인 로고"
            />
          </Link>
        </MainLogoBox>
        <MainMenuBox>
          <ul>
            <li>
              <Link to="/projectdongstagram">
                <FontAwesomeIcon icon="fa-solid fa-house menuIcon" />
                <p>홈</p>
              </Link>
            </li>
            <li className="searchBtn" onClick={searchBtnClicked}>
              <Link>
                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass menuIcon" />
                <p>검색</p>
              </Link>
            </li>
            <li>
              <Link to="/video">
                <FontAwesomeIcon icon="fa-solid fa-film" />
                <p>숏폼</p>
              </Link>
            </li>
            {/* <li>
              <FontAwesomeIcon icon="fa-solid fa-heart menuIcon" />
              <p>알림</p>
            </li> */}
            <li>
              <Link to="/proflie">
                <FontAwesomeIcon icon="fa-solid fa-user menuIcon" />
                <p>프로필</p>
              </Link>
            </li>
          </ul>
        </MainMenuBox>
        <SettingBox>
          <div className="settingIconBox">
            <Link to="/setting">
              <FontAwesomeIcon icon="fa-solid fa-gear" />
              <p>설정</p>
            </Link>
          </div>
        </SettingBox>
      </MainMenuWrap>
      <MobileMainMenuWrap>
        <MobileLogoBox>
          <Link to="/">
            <img
              src="https://dongsooo.github.io/imgs/dongstgram_img/00_main_logo.png"
              alt=""
            />
          </Link>
        </MobileLogoBox>
        <MobileSearchBox>
          <div className="searchBox">
            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass menuIcon" />
            <PlaceholderText focused={focused}>검색</PlaceholderText>
            <SearchInput
              type="text"
              focused={focused}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              placeholder="검색"
              value={searchWord}
              onChange={(e) => {
                setSearchWord(e.target.value);
              }}
            />
          </div>
          {/* <div className="alertBox">
            <FontAwesomeIcon icon="fa-solid fa-heart" />
          </div> */}
        </MobileSearchBox>
      </MobileMainMenuWrap>
      <MobileBottomMenuWrap>
        <ul>
          <li>
            <Link to="/projectdongstagram">
              <FontAwesomeIcon icon="fa-solid fa-house" />
            </Link>
          </li>
          <li>
            <Link to="/video">
              <FontAwesomeIcon icon="fa-solid fa-film" />
            </Link>
          </li>
          <li>
            <Link to="/proflie">
              <FontAwesomeIcon icon="fa-solid fa-user" />
            </Link>
          </li>

          <li>
            <Link to="/setting">
              <FontAwesomeIcon icon="fa-solid fa-gear" />
            </Link>
          </li>
        </ul>
      </MobileBottomMenuWrap>
    </>
  );
};

export default MainMenu;

const MainMenuWrap = styled.div`
  width: 100%;
  max-width: 240px; /* 화면이 좁아지면 이 너비를 조절 */
  height: 100vh;
  overflow: hidden; /* 가로 스크롤 방지 */
  border-right: 1px solid #eaeaea;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  @media (max-width: 1264px) {
    max-width: 80px; /* 이 부분도 화면 너비에 맞게 조정 */
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

const MainLogoBox = styled.div`
  width: 100%;
  height: 140px;
  margin: 0 auto;
  position: relative;
  background-color: white;

  .pcLogo {
    width: 55%;
    position: absolute;
    left: 40%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .tabletLogo {
    width: 30%;
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  @media (max-width: 1264px) {
    .tabletLogo {
      display: block;
      background-color: white;
    }
    .pcLogo {
      display: none;
      background-color: white;
    }
  }
`;

const MainMenuBox = styled.div`
  width: 100%;
  margin: 0 auto;
  background-color: white;

  li {
    position: relative;
    margin: 10px 20px;
    font-size: 1em;
    display: flex;
    padding: 10px 0;
    border-radius: 10px;
    height: 30px;
    align-items: center;
    overflow: hidden;

    a {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 10px 0;
    }

    .fa-house,
    .fa-magnifying-glass,
    .fa-heart,
    .fa-user,
    .fa-film {
      font-size: 1.4em;
      margin-right: 20px;
      margin-left: 10px;
      /* transition: all 0.2s; */
    }
    &:first-child {
      margin-top: 0;
    }
    &:hover {
      background-color: #eaeaea;
    }
  }

  li:hover .fa-house,
  li:hover .fa-magnifying-glass,
  li:hover .fa-heart,
  li:hover .fa-user,
  li:hover .fa-film {
    font-size: 1.6em;
  }
  @media (max-width: 1264px) {
    p {
      display: none;
    }
    li {
      padding: 0;
      height: 50px;
    }
    .fa-house,
    .fa-magnifying-glass,
    .fa-heart,
    .fa-user,
    .fa-film {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-right: 0 !important;
      margin-left: 0 !important;
    }
  }
`;

const SettingBox = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: end;
  background-color: white;

  .settingIconBox {
    position: relative;
    width: 100%;

    display: flex;
    margin: 10px 20px;
    margin-bottom: 20px;
    font-size: 1em;
    display: flex;
    padding: 10px 0;
    border-radius: 10px;
    height: 30px;
    align-items: center;
    a {
      width: 100%;
      display: flex;
      align-items: center;
    }
    .fa-gear {
      font-size: 1.4em;
      margin-right: 20px;
      margin-left: 10px;
      /* transition: all 0.2s; */
    }
    &:hover {
      background-color: #eaeaea;
    }
    &:hover .fa-gear {
      font-size: 1.6em;
    }
  }
  @media (max-width: 1264px) {
    p {
      display: none;
    }
    .fa-gear {
      margin-left: 0 !important;
      margin-right: 0 !important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

const MobileMainMenuWrap = styled.div`
  width: 100%;
  height: 60px;
  max-width: 767px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  border-bottom: 1px solid #eaeaea;
  background-color: white;

  @media (min-width: 768px) {
    display: none;
  }
  @media (max-width: 767px) {
    display: flex;
  }
`;

const MobileLogoBox = styled.div`
  height: 100%;
  margin-left: 20px;
  margin-right: 20px;
  flex: 1;

  a {
    height: 100%;
    display: flex;
    align-items: center;

    img {
      height: 70%;
      width: 79px;
    }
  }
`;

const MobileSearchBox = styled.div`
  height: 100%;
  margin-right: 20px;
  display: flex;

  .searchBox {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;

    .fa-magnifying-glass {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .alertBox {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;

    .fa-heart {
      font-size: 2em;
      color: #f9b8b8;
    }
  }
`;

const PlaceholderText = styled.p`
  position: absolute;
  left: 40px; /* 아이콘과 겹치지 않도록 */
  color: #888;
  font-size: 16px;
  margin: 0;
  transition: opacity 0.3s;
  opacity: ${(props) => (props.focused ? 0 : 1)};
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px 10px 10px 40px; /* 왼쪽에 아이콘 크기만큼 패딩 추가 */
  border: none;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
  transition: opacity 0.3s;
  opacity: ${(props) =>
    props.focused ? 1 : 0.8}; /* 비활성화 상태일 때 약간의 투명도 */
  background-color: ${(props) => (props.focused ? "#ffffff" : "#edecec")};
`;

const MobileBottomMenuWrap = styled.div`
  width: 100%;
  max-width: 100%; /* 화면 너비에 맞추기 */
  height: 48px;
  position: fixed;
  bottom: 0;
  left: 0;
  border-top: 1px solid #eaeaea;
  z-index: 3;
  background-color: white;
  overflow-x: hidden; /* 가로 스크롤 방지 */

  @media (min-width: 768px) {
    display: none;
  }
  @media (max-width: 767px) {
    display: block;
  }

  ul {
    max-width: 767px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    li {
      /* margin: 0 50px; */

      a {
        display: block;
        font-size: 1.6em;
      }
    }
  }
`;
